import { render, staticRenderFns } from "./ChatroomIndexBackup.vue?vue&type=template&id=0ff79f4f&scoped=true&"
import script from "./ChatroomIndexBackup.vue?vue&type=script&lang=js&"
export * from "./ChatroomIndexBackup.vue?vue&type=script&lang=js&"
import style0 from "./ChatroomIndexBackup.vue?vue&type=style&index=0&id=0ff79f4f&lang=scss&scoped=true&"
import style1 from "./ChatroomIndexBackup.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff79f4f",
  null
  
)

export default component.exports